import { Component, EventEmitter, Input, Output } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

export enum PicklistView{
  NA = 0,
  ContactView = 1,
  ClientView = 2,
}

@Component({
  selector: 'app-picklist-modal',
  templateUrl: './picklist-modal.component.html',
  styleUrls: ['./picklist-modal.component.scss']
})
export class PicklistModalComponent {
  constructor(
    private modalRef: NgbActiveModal,
    ) { }

  @Input() public model:any;  
  @Input() public display: PicklistView = PicklistView.NA;
  @Output() modelChange = new EventEmitter<any>();

  submitted: boolean = false; 
  enumPicklistView = PicklistView; 

  close(){
      if(this.model && this.model.id){
        this.modelChange.emit(this.model);
      }
      this.modalRef.close();
  }
}
